/* ==========================================================================
   RATAJ WATCHES — theme.js  (global UI behaviours)
   ========================================================================== */
(function () {
  'use strict';

  /* ---- 1. PRELOADER (min. czas pokazania + bezpiecznik) ----------------- */
  var pre = document.getElementById('rtj-preloader');
  if (pre) {
    var MIN = 1700;
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    var removed = false;
    var hidePre = function () {
      if (removed) return;
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      var waited = now - t0;
      var go = function () {
        if (removed) return;
        removed = true;
        pre.classList.add('is-done');
        setTimeout(function () { if (pre && pre.parentNode) pre.parentNode.removeChild(pre); }, 900);
      };
      if (waited >= MIN) { go(); } else { setTimeout(go, MIN - waited); }
    };
    if (document.readyState === 'complete') { hidePre(); }
    else { window.addEventListener('load', hidePre); }
    setTimeout(hidePre, 4500);
  }

  /* ---- 2. HEADER scroll state ------------------------------------------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- 3. OVERLAY MENU --------------------------------------------------- */
  var overlay = document.querySelector('.nav-overlay');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtns = document.querySelectorAll('[data-menu-close]');
  var setMenu = function (open) {
    if (!overlay) return;
    overlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  closeBtns.forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* ---- 3b. SCROLL / NAWIGACJA do kotwic (działa też z podstron) --------- */
  function scrollToHash(id) {
    if (!id) { window.scrollTo({ top: 0, behavior: 'smooth' }); return true; }
    var target = document.getElementById(id);
    if (!target) return false;
    var h = document.querySelector('.site-header');
    var offset = h ? h.offsetHeight + 12 : 16;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var raw = a.getAttribute('href') || '';
    var id = null;
    if (raw.charAt(0) === '#') { id = raw.slice(1); }
    else if (raw.slice(0, 2) === '/#') { id = raw.slice(2); }
    else if (raw === '/') { id = '__home__'; }
    if (id === null) return;                       // zwykły link — normalna nawigacja

    var onHome = (location.pathname === '/');

    if (id === '__home__') {                        // link do strony głównej
      if (onHome) {
        e.preventDefault();
        if (overlay && overlay.classList.contains('is-open')) setMenu(false);
        scrollToHash('');
        if (history.replaceState) history.replaceState(null, '', '/');
      }
      return;                                        // z podstrony — niech przeglądarka przejdzie na /
    }

    if (id && document.getElementById(id)) {         // kotwica jest na tej stronie → płynny scroll
      e.preventDefault();
      if (overlay && overlay.classList.contains('is-open')) setMenu(false);
      scrollToHash(id);
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      return;
    }

    // kotwicy NIE ma na tej stronie (np. jesteś w koszyku) → przerzuć na stronę główną + kotwicę
    e.preventDefault();
    window.location.href = '/#' + id;
  });

  /* po wejściu z hashem (np. z innej strony) — dosuń z offsetem nagłówka */
  if (location.hash && location.hash.length > 1) {
    var hid = location.hash.slice(1);
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToHash(hid); }, 80);
    });
  }

  /* ---- 4. FAQ accordion -------------------------------------------------- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---- 5. REVEAL on scroll ---------------------------------------------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- 6. CART COUNT (live) --------------------------------------------- */
  window.rtjRefreshCart = function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.setAttribute('data-empty', c.item_count === 0 ? 'true' : 'false');
        });
      })
      .catch(function () {});
  };
  window.rtjRefreshCart();

  /* ---- 7. STICKY BUY BAR (pojawia się po sekcji produktu #edition) ------ */
  var buyBar = document.querySelector('.buy-bar');
  if (buyBar && 'IntersectionObserver' in window) {
    var anchorSec = document.getElementById('edition') || document.querySelector('.edition');
    var sentinel;
    if (anchorSec) {
      sentinel = document.createElement('span');
      sentinel.setAttribute('data-buybar-sentinel', '');
      sentinel.setAttribute('aria-hidden', 'true');
      anchorSec.parentNode.insertBefore(sentinel, anchorSec.nextSibling);
    } else {
      sentinel = document.querySelector('[data-buybar-sentinel]');
    }
    if (sentinel) {
      var bio = new IntersectionObserver(function (entries) {
        buyBar.classList.toggle('is-visible', entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      bio.observe(sentinel);
    }
  }
})();
